import { render, staticRenderFns } from "./StarshipsModifications.vue?vue&type=template&id=08a918e9&lang=pug&"
import script from "./StarshipsModifications.vue?vue&type=script&lang=ts&"
export * from "./StarshipsModifications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports